import Immutable from 'seamless-immutable';

export default Immutable({
  PRODUCTION: 'prod',
  QA: 'qa',
  DEV: 'dev',
});
